import React, { Component } from 'react';
import { Section } from './ui/Section';
import { XCircle, Heart, AlertTriangle, Volume2, Zap, Gift, Megaphone, Sparkles } from 'lucide-react';
export function PainPoints() {
  const painPhrases = [{
    text: 'Gritos',
    icon: Volume2
  }, {
    text: 'Resistencia',
    icon: XCircle
  }, {
    text: 'Apuros',
    icon: Zap
  }, {
    text: 'Culpa',
    icon: Heart
  }];
  const failedAttempts = [{
    title: 'Gritar',
    icon: Volume2,
    desc: 'Funciona una vez… y después necesitas gritar más fuerte.'
  }, {
    title: 'Castigar en caliente',
    icon: Zap,
    desc: 'Convierte la mañana en una guerra de poder.'
  }, {
    title: 'Premiar improvisando',
    icon: Gift,
    desc: "Crea la frase que destruye todo: '¿y qué me das?'"
  }, {
    title: 'Explicar demasiado',
    icon: Megaphone,
    desc: 'Cuando ya está desregulado, solo alarga el caos.'
  }];
  return <>
      <Section background="white" data-id="element-246">
        <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-247">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-red-50 text-red-500 font-semibold text-sm" data-id="element-248">
            <AlertTriangle className="w-4 h-4 mr-2" data-id="element-249" />
            ¿Te suena familiar?
          </div>

          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800" data-id="element-250">
            Cada <span className="text-[#E8845F]" data-id="element-251">"¡apúrate!"</span> y cada{' '}
            <span className="text-[#E8845F]" data-id="element-252">"¿por qué no me haces caso?"</span>{' '}
            solo sube la frustración
          </h2>

          <div className="flex flex-wrap justify-center gap-3" data-id="element-253">
            {painPhrases.map((phrase, idx) => {
            const IconComponent = phrase.icon;
            return <span key={idx} className="px-4 py-2 bg-gradient-to-r from-red-50 to-orange-50 rounded-full text-gray-700 font-medium text-lg border border-red-100 inline-flex items-center gap-2" data-id="element-254">
                  <IconComponent className="w-4 h-4 text-red-400" data-id="element-255" />
                  {phrase.text}
                </span>;
          })}
          </div>

          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-256">
            Y terminas <span className="font-bold text-[#E8845F]" data-id="element-257">agotada</span>
            … con el día pesado antes de empezar.
          </p>

          <div className="p-6 bg-gradient-to-br from-[#FFF5F0] to-[#FFEDD5] rounded-3xl border-2 border-[#E8845F]/20 shadow-sm" data-id="element-258">
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-259">
              Pasa porque estás intentando dirigir una cadena de{' '}
              <span className="font-bold text-[#E8845F]" data-id="element-260">
                transiciones invisibles
              </span>{' '}
              con palabras. Y un niño cansado, apurado o desregulado{' '}
              <span className="font-semibold" data-id="element-261">
                no coopera mejor por escuchar más
              </span>
              .
            </p>
          </div>
        </div>
      </Section>

      <Section background="cream" data-id="element-262">
        <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-263">
          <div data-id="element-264">
            <h3 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-8" data-id="element-265">
              Por qué "lo que ya intentaste"{' '}
              <span className="text-[#E8845F]" data-id="element-266">no se sostiene</span>
            </h3>
            <div className="space-y-4" data-id="element-267">
              {failedAttempts.map((item, idx) => {
              const IconComponent = item.icon;
              return <div key={idx} className="flex items-start p-4 bg-white/80 rounded-2xl border border-red-100/50 shadow-sm" data-id="element-268">
                    <div className="bg-red-100 rounded-full p-2 mr-4 flex-shrink-0" data-id="element-269">
                      <XCircle className="w-5 h-5 text-red-400" data-id="element-270" />
                    </div>
                    <div data-id="element-271">
                      <h4 className="font-bold text-gray-800 flex items-center gap-2" data-id="element-272">
                        <IconComponent className="w-4 h-4 text-gray-500" data-id="element-273" />
                        {item.title}
                      </h4>
                      <p className="text-gray-600 text-sm mt-1" data-id="element-274">{item.desc}</p>
                    </div>
                  </div>;
            })}
            </div>
          </div>

          <div className="bg-white p-8 rounded-3xl shadow-xl border-2 border-[#E6F4F4] relative overflow-hidden" data-id="element-275">
            <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#F5C842] opacity-10 rounded-full blur-2xl" data-id="element-276"></div>
            <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#F5C842] to-[#FFD966] rounded-full mb-6 mx-auto shadow-lg" data-id="element-277">
              <Heart className="w-10 h-10 text-white fill-current" data-id="element-278" />
            </div>
            <h3 className="text-2xl font-extrabold text-center text-gray-800 mb-4 flex items-center justify-center gap-2" data-id="element-279">
              La verdad (liberadora)
              <Sparkles className="w-5 h-5 text-[#F5C842]" data-id="element-280" />
            </h3>
            <p className="text-center text-gray-600 mb-4 leading-relaxed" data-id="element-281">
              Tu hijo no está siendo "malo".
            </p>
            <p className="text-center text-gray-600 mb-6 leading-relaxed" data-id="element-282">
              Cuando no puede anticipar lo que viene, intenta recuperar control
              con lo único que tiene:
              <span className="font-semibold" data-id="element-283">
                {' '}
                resistencia, llanto, "no", distracción y pelea
              </span>
              .
            </p>
            <div className="text-center" data-id="element-284">
              <span className="inline-flex items-center gap-2 bg-gradient-to-r from-[#4AAAA5] to-[#5CBFBA] text-white font-bold px-6 py-4 rounded-2xl shadow-lg text-lg" data-id="element-285">
                <Heart className="w-5 h-5 fill-current" data-id="element-286" />
                No te falta amor. Te falta un sistema repetible.
              </span>
            </div>
          </div>
        </div>
      </Section>
    </>;
}